/**
 * Google OAuth Configuration
 * Update REACT_APP_GOOGLE_CLIENT_ID in your .env file
 */

export const getOAuthConfig = () => {
  return {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_CLIENT_ID.apps.googleusercontent.com',
    redirectUri: `${window.location.origin}/auth/google/callback`,
    scope: 'openid email profile',
    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/v2/auth',
    tokenEndpoint: 'https://oauth2.googleapis.com/token',
  };
};

/**
 * Backend API configuration
 */
export const getBackendConfig = () => {
  return {
    baseUrl: process.env.REACT_APP_API_BASE || 'http://localhost:8005',
    googleLoginEndpoint: '/auth/google/login',
  };
};

/**
 * Generate Google OAuth authorization URL
 */
export const generateGoogleAuthUrl = () => {
  const config = getOAuthConfig();
  const state = generateRandomState();
  sessionStorage.setItem('oauth_state', state);

  const params = new URLSearchParams({
    client_id: config.clientId,
    redirect_uri: config.redirectUri,
    response_type: 'code',
    scope: config.scope,
    state: state,
    access_type: 'offline',
    prompt: 'consent',
  });

  return `${config.authorizationEndpoint}?${params.toString()}`;
};

/**
 * Generate random state for CSRF protection
 */
function generateRandomState() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
